<template>
  <div :id="$style.customer_voice_detail">
    <div :class="$style.tape">
      <div :class="$style.impression">
        <p :class="$style.subtitle">ミュージアムの感想</p>
        <div :class="$style.text">{{ item.impression }}</div>
      </div>
      <div :class="$style.motive">
        <p :class="$style.subtitle">ミュージアムに訪れようと思った動機</p>
        <div :class="$style.text">{{ item.motive }}</div>
      </div>
      <div :class="$style.message">
        <p :class="$style.subtitle">松井選手へのメッセージ・その他</p>
        <div :class="$style.text">{{ item.message }}</div>
      </div>

      <div :class="$style.table">
        <div :class="$style.left">
          <tr>
            <td>旅行の種類:</td>
            <td>{{ item.choice_type }}</td>
          </tr>
          <tr>
            <td>ご同伴者:</td>
            <td>{{ item.choice_with }}</td>
          </tr>
          <tr>
            <td>性別:</td>
            <td>{{ item.choice_gender }}</td>
          </tr>
          <tr>
            <td>年齢:</td>
            <td>{{ item.age }}</td>
          </tr>
        </div>
        <div :class="$style.right">
          <tr>
            <td>交通手段:</td>
            <td>{{ item.choice_trans }}</td>
          </tr>
          <tr>
            <td>お住まい:</td>
            <td>{{ item.choice_local }}</td>
          </tr>
          <tr>
            <td>ご来館回数:</td>
            <td>{{ item.repeat }}</td>
          </tr>
          <tr>
            <td>ご来館日:</td>
            <td>{{ item.visit_date}}</td>
          </tr>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "CustomerVoiceDetail",
  props: {
    item: {
      type: Object
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #customer_voice_detail {
    // margin: 20px 30px;
    margin: 20px 0px;
    font-size: 13px;
    text-align: center;
    .tape {
      position: relative;
      // background: #fff0cd;
      background: #fff;
      // box-shadow: 0px 0px 0px 5px #fff0cd;
      box-shadow: 0px 0px 0px 5px #fff;
      // border: dashed 2px white;
      // border: dashed 2px #fff0cd;
      padding: 1em 0.5em;
      color: #454545;
      width: 300px;
      &:after {
        position: absolute;
        content: "";
        right: -7px;
        top: -7px;
        border-width: 0 15px 15px 0;
        border-style: solid;
        // border-color: #ffdb88 #e0f5e7 #ffdb88;
        border-color: #fff #e0f5e7 #fff;
        box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15);
      }
      .table {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        background: #fff;
        padding: 10px 0px;
        div {
          margin: 0px 2px;
          tr {
            width: 100%;
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #000;
            td {
              margin-left: 5px;
              display: inline-block;
            }
          }
        }
        .left {
          width: 150px;
        }
        .right {
          width: 170px;
        }
      }
      p {
        margin: 0;
        padding: 0;
      }
      .subtitle {
        font-size: 14px;
        // background: #fff;
        background: #fff0cd;
        width: 100%;
        // padding-left: 20px;
        border-top: 4px solid #fff0cd;
      }
      .text {
        padding: 10px 12px;
        border: 4px solid #fff0cd;
      }
      .message {
        // border-bottom: 10px double #747474;
      }
      .table {
        border: 4px solid #fff0cd;
        margin-top: 0px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #customer_voice_detail {
    margin: 20px 30px;
    font-size: 15px;
    .tape {
      position: relative;
      background: #fff0cd;
      box-shadow: 0px 0px 0px 5px #fff0cd;
      border: dashed 2px white;
      padding: 1em 0.5em;
      color: #454545;
      width: 450px;
      &:after {
        position: absolute;
        content: "";
        right: -7px;
        top: -7px;
        border-width: 0 15px 15px 0;
        border-style: solid;
        border-color: #ffdb88 #e0f5e7 #ffdb88;
        box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.15);
      }
      .table {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        background: #fff;
        padding: 10px 0px;
        div {
          margin: 0px 4px;
          tr {
            width: 100%;
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #000;
            td {
              margin-left: 5px;
              display: inline-block;
            }
          }
        }
        .left {
          width: 150px;
        }
        .right {
          width: 170px;
        }
      }
      p {
        margin: 0;
        padding: 0;
      }
      .subtitle {
        font-size: 18px;
        background: #fff;
        width: 100%;
        padding-left: 20px;
      }
      .text {
        padding: 10px 12px;
      }
      .message {
        border-bottom: 10px double #747474;
      }
    }
  }
}
</style>